export default "__VITE_ASSET__D__rdrp$__"